import {selector} from './selector';
import * as events from "./events";

const PageCustomerCameras = (function ($) {

    function initEvents() {
        const $videoModal = $(selector.videoModal);
        $(selector.cameraCard).on("click", events.displayCameraFeed);

        $videoModal.on("hidden.bs.modal", events.pauseCameraFeed);


    }


    function initialize() {
        initEvents();
    }

    return {
        init: initialize
    }
})(jQuery);

export {PageCustomerCameras};
